import { StockActions } from "../contants/Modules.Action.Type";

export const StockChangeHandler =
  (e, data = false) =>
  (dispatch, getstate) => {
    let Entry = getstate().Stock.Entry;
    if (!data && e.target) {
      Entry[e.target.name] = e.target.value;
    } else {
      Entry[data] = e;
    }
    dispatch({
      type: StockActions.STOCK_CHANGE_HANDLER,
      payload: { Entry },
    });
  };

export const StockAddParticular = (e) => (dispatch, getstate) => {
  let alreadyExists = false;
  const StockData = getstate().Stock.Entry;
  const particular = StockData.particulars.slice();
  particular.forEach((x) => {
    if (x.id === e.id) {
      alreadyExists = true;
      x.qty = x.qty + parseFloat(e.qty);
      x.damage = x.damage + parseFloat(e.damage);
      x.expire = e.expire;
      x.remark = e.remark;
    }
  });
  if (!alreadyExists && e.name) {
    let newdata = {
      name: e.name,
      id: e.id,
      qty: parseFloat(e.qty),
      damage: parseFloat(e.damage),
      expire: e.expire,
      remark: e.remark,
    };
    particular.push({ ...newdata });
  }
  const Entry = StockData;
  Entry.particulars = particular;
  dispatch({
    type: StockActions.STOCK_PARTICULAR,
    payload: { Entry },
  });
};

export const removeStockParticular = (e) => (dispatch, getstate) => {
  const StockData = getstate().Stock.Entry;
  let Particular = StockData.particulars.slice();
  const selectProduct = Particular.find((items) => items.id === e.id);
  const index = Particular.indexOf(selectProduct);
  Particular.splice(index, 1);
  const Entry = StockData;
  Entry.particulars = Particular;
  dispatch({
    type: StockActions.REMOVE_STOCK_PARTICULAR,
    payload: { Entry },
  });
};

export const setDefaultStockData = (e) => (dispatch) => {
  const Entry = {
    date: "",
    note: "",
    employee: "",
    particulars: [],
  };
  dispatch({
    type: StockActions.SET_STOCK_TO_DEFAULT,
    payload: { Entry },
  });
};
